<template>
  <b-row class="m-auto">
    <b-col cols="12">
      <div class="no-records-message" v-if="hasNoData">
        <span class="far fa-times-circle custom-icon"></span>
        <span class="font-weight-bold mb-2">{{
          $t('module-information.no-result')
        }}</span>
        <span>{{ $t('module-information.empty-message') }}</span>
      </div>
      <accordion-panel
        v-else
        id="module-information"
        :collapsed="collapse"
        @update:collapsed="handleCollapsed"
      >
        <template #title>
          <label class="module-information-panel__module-information-title">
            {{ $t('module-information.external-access') }}
          </label>
        </template>
        <b-row v-for="item in items" :key="item.index" class="links">
          <b-col lg="8" sm="12">
            <div>
              <h3 class="module-information-panel__module-information-display-name">
                {{ item.displayName }}
              </h3>
              <span class="module-information-panel__module-information-address">
                {{ item.address }}
              </span>
            </div>
          </b-col>
          <b-col lg="4" sm="12" class="text-lg-right text-sm-center">
            <b-dropdown
              split
              variant="primary"
              @click="openConfirmationModal(item)"
              class="dropdown-margin"
            >
              <template #button-content>
                <i class="fas fa-external-link-alt mr-1" aria-hidden="true" />
                <span>{{ $t('module-information.actions.access') }}</span>
              </template>
              <b-dropdown-item>
                <b-btn
                  class="my-3 my-sm-0"
                  block
                  variant="outline-primary"
                  @click="openEditModal(item)"
                >
                  <i class="fas fa-pencil-alt mr-1" aria-hidden="true" />
                  <span>{{ $t('module-information.actions.edit') }}</span>
                </b-btn>
              </b-dropdown-item>
            </b-dropdown>
          </b-col>
        </b-row>
      </accordion-panel>
      <module-information-confirm-modal
        v-model="showConfirmationModal"
        :link="selectedItem.address"
        @refresh="refreshData"
      />
      <module-information-edit-modal
        v-model="showEditModal"
        :item="selectedItem"
        @refresh="refreshData"
      />
    </b-col>
  </b-row>
</template>

<script>
import AccordionPanel from '@/components/AccordionPanel';
import ModuleInformationConfirmModal from '@/app/installation/supervision/ModuleInformationConfirmModal';
import ModuleInformationEditModal from '@/app/installation/supervision/ModuleInformationEditModal';
import ModuleInformationService from '@/domain/services/installation/supervision/sensors/moduleInformation';

export default {
  components: {
    AccordionPanel,
    ModuleInformationConfirmModal,
    ModuleInformationEditModal,
  },
  props: {
    sensor: Object,
  },

  data() {
    return {
      items: [],
      showConfirmationModal: false,
      showEditModal: false,
      selectedItem: { address: '', displayName: '' },
      collapse: false,
    };
  },
  mounted() {
    this.refreshData();
  },
  computed: {
    hasNoData() {
      return this.items.length === 0;
    },
  },
  methods: {
    handleCollapsed() {
      this.collapse = !this.collapse;
    },
    async refreshData() {
      try {
        this.items = await ModuleInformationService.getModuleInformation(
          this.sensor.id,
        );
      } catch (error) {
        this.$pushAlert({ code: 'ME010' });
      }
    },
    openConfirmationModal(item) {
      this.selectedItem = item;
      this.showConfirmationModal = true;
    },
    openEditModal(item) {
      this.selectedItem = item;
      this.showEditModal = true;
    },
  },
};
</script>

<style lang="sass" scoped>
@import "src/styles/defaults/variables"

.accordion-container
  min-height: 130px
.module-information-panel
  &__module-information-title
    color: $color-primary
    font-size: 1.1rem
    margin-bottom: 0
    font-weight: bold
  &__module-information-display-name
    font-size: 1.1rem
    font-weight: bold
    overflow: hidden
    word-wrap: break-word
  &__module-information-address
    font-size: 0.8rem
    margin-bottom: 0
    overflow: hidden
    word-wrap: break-word
::v-deep .accordion-panel
  border: var(--color-border-inner) 1px solid
  border-radius: 5px
  box-shadow: none
  padding-bottom: 6px

::v-deep .accordion-panel__body
  align-content: flex-end !important
  margin-right: 10px
  align-items: baseline !important
::v-deep .accordion-panel__header
    background-color: transparent
::v-deep
      .dropdown-menu.show
        padding: 0 !important
        width: 100% !important
      .dropdown-item
        padding: 0

        & > button
          margin-top: 0 !important
          margin-bottom: 0 !important
.links
  padding: 20px
  margin-bottom: 16px
  margin-left: 2px
  margin-right: 2px
  border: var(--color-border-inner) 1px solid
  border-radius: 2px
  box-shadow: none

.links:hover
  background-color: var(--color-border-outer)

.no-records-message
  display: flex
  flex-direction: column
  min-height: 200px
  align-content: center
  align-items: center
  justify-content: center

.custom-icon
  font-size: 40px
  margin-bottom: 10px

@media only screen and (max-width: 600px)
  .dropdown-margin
    margin-top: 16px
</style>
